/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import API from "../../Utils/Interceptor/ApiMiddleware";

export default function AddToJob({
  open,
  onClose,
  candidateId = [],
  setSnackbar,
  onSuccessfulAdd,
}) {
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [jobsData, setJobsData] = useState([]);
  const [failedCandidatesData, setFailedCandidatesData] = useState([]);

  const getAllJobs = async () => {
    try {
      const response = await API.get("/job/get-all-active-jobs");
      if (response?.data?.success) {
        setJobsData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching job details", error);
    }
  };
  useEffect(() => {
    if (open) {
      getAllJobs();
    }
  }, [open]);
  const handleAdd = async () => {
    if (!selectedJobId) return;

    setLoading(true);

    try {
      const res = await API.post("/job/apply-job", {
        candidate_ids: candidateId,
        job_id: selectedJobId,
        isShortlisted: 0,
        quesAnsArray: [],
      });

      const data = res?.data?.data;

      if (data?.success_candidates > 0) {
        setSnackbar({
          open: true,
          message: data.message,
          severity: "success",
        });
      }

      if (data?.details?.length > 0) {
        setFailedCandidatesData(data.details);
        setTimeout(() => {
          handleClose();
          setFailedCandidatesData([]);
        }, 5000);
      } else {
        handleClose();
      }

      if (onSuccessfulAdd) {
        onSuccessfulAdd();
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: err?.response?.data?.message || "Something went wrong",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSelectedJobId(null);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 500,
          borderRadius: "10px",
          position: "relative",
        },
      }}
    >
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(255, 255, 255, 0.6)",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <DialogTitle>
        <Typography fontWeight="bold" variant="h5">
          Add to Job
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography sx={{ mb: 0.5 }}>Select a job</Typography>
        <Autocomplete
          disablePortal={false}
          fullWidth
          size="small"
          options={jobsData}
          getOptionLabel={(option) =>
            option?.title ? `${option.title} (ID: ${option.joborder_id})` : ""
          }
          onChange={(event, newValue) =>
            setSelectedJobId(newValue?.joborder_id || null)
          }
          renderInput={(params) => <TextField {...params} label="Job" />}
          sx={{ mt: 1 }}
        />
        {failedCandidatesData.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Typography sx={{ fontSize: "14px", mb: 1 }}>
              {failedCandidatesData.length > 1 ? "These" : "This"}{" "}
              {failedCandidatesData.length} candidate
              {failedCandidatesData.length > 1 ? "s are" : " is"} already
              available in this job. The remaining candidate
              {failedCandidatesData.length > 1 ? "s have" : " has"} been added
              successfully.
            </Typography>

            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                borderRadius: "6px",
                padding: "8px",
                fontSize: "13px",
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              {failedCandidatesData.map((candidate, index) => (
                <Box
                  key={`${candidate.email1}-${index}`}
                  sx={{
                    backgroundColor: "#ffecec",
                    borderRadius: "10px",
                    padding: "8px",
                    width: "calc(50% - 4px)",
                    boxSizing: "border-box",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Typography sx={{ fontWeight: 600 }}>
                    {candidate.first_name || "Unnamed"}
                  </Typography>
                  <Typography>{candidate.email1}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </DialogContent>
      <Divider />
      <DialogActions sx={{ padding: "12px 24px" }}>
        <Button onClick={handleClose} size="small" disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleAdd}
          size="small"
          disabled={
            !selectedJobId || loading || failedCandidatesData.length > 0
          }
          variant="contained"
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
